<template>
    <div class="paying">

    </div>
</template>

<script>
export default {
  name: "paying",
  data: function() {
    return {
      order_sn: this.$route.query.order_sn, //订单编号
      order_id: this.$route.query.order_id //订单ID
    };
  },
  inject: ["showMsg"],
  mounted: function() {
    layer.open({
      type: 2,
      content: "正在支付，请稍后",
      shadeClose: true
    });
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    },
    hurl: function() {
      return this.$store.state.hurl;
    }
  },
  methods: {
    // 检查是否支付成功的轮询方法
    ajaxTimerToCheckOrderPayStatus: function() {
      let stopNum = setInterval(() => {
        this.$http({
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          method: "post",
          url: this.weburl + this.hurl + "/Api/check_order_pay_status",
          dataType: "json",
          data: {
            order_id: this.$route.query.order_id
          }
        })
          .then(res => {
            // console.log(res.data);
            if (res.data.result.pay_status == 1) {
              this.userPayStatus = 1;
              clearInterval(stopNum);
              this.$router.push({
                path: "/drawABill",
                query: { order_id: this.order_id, order_sn: this.order_sn }
              });
            } else {
              this.showMsg("支付失败，稍后再试");
              setTimeout(() => {
                this.$router.push({
                  path: "/orderPayChoose",
                  query: { order_id: this.order_id, order_sn: this.order_sn }
                });
              }, 1000);
            }
          })
          .catch(() => {
            this.showMsg("网络错误，请稍后再试");
          });
      }, 1000);
    }
  }
};
</script>

<style scoped>
.paying {
  height: 60vh;
}
</style>
